import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';
import { FiDownload } from 'react-icons/fi';
import moment from 'moment';
import { checkNullAndUndefined, replaceDayInDateString } from '../../Utilities/utils';
import bookingConfirmation from "../../../src/widgets/bookingWidget/clubProfileCreditPackage/images/bookingConfirmation.png"

const OneTimeSuccessModal = ({
    totalPayment,
    clubData,
    membership,
    setOpenPrivateMembershipModal,
    setOpenOneTimeSuccessModal,
    receiptUrl,
} : {
    totalPayment: String;
    clubData: any;
    membership: any;
    setOpenPrivateMembershipModal: Dispatch<SetStateAction<boolean>>;
    setOpenOneTimeSuccessModal: Dispatch<SetStateAction<boolean>>;
    receiptUrl?: any;
}) => {
    const {t} = useTranslation();
    const fallbackTimeZone = clubData?.timezone || moment.tz.guess();
    const _startTime = moment(membership?.start_date).tz(fallbackTimeZone);
    const _formattedStartTime = _startTime.format('HH:mm');
    const _endTime = moment(membership?.end_date).tz(fallbackTimeZone);
  const _formattedEndTime = _endTime.format('HH:mm');

  const formatDate = (da: any) => {

    const dayMap = {
      "Sun": t("sunday"),
      "Mon": t("monday"),
      "Tue": t("tuesday"),
      "Wed": t("wednesday"),
      "Thu": t("thursday"),
      "Fri": t("friday"),
      "Sat": t("saturday")
    };

    let dateNew = "";
    if (!checkNullAndUndefined(clubData?.timezone) && clubData?.timezone !== "") {
     dateNew = moment(da)?.tz(clubData?.timezone)?.format("ddd DD MMM");
     return replaceDayInDateString(dateNew, dayMap);
    }
    dateNew = moment(da)?.format("ddd DD MMM");
    return replaceDayInDateString(dateNew, dayMap);
  };
  return (
    <div className="bg-white font-semibold rounded w-full max-w-lg sm:min-w-[512px] mx-auto z-[5100]">
        <div className="text-white bg-secondary py-5 flex items-center justify-between flex-wrap gap-4 md:rounded-t text-2xl font-semibold px-5">
            <h4
                id="paymentSuccess"
                className="text-2xl lg:text-3xl font-semibold"
            >
                {t("BookingModal.paymentSuccessful")}
            </h4>
            <button
                className="btn"
                onClick={() => {
                    setOpenPrivateMembershipModal(false);
                }}
            >
                <AiOutlineClose className="pointer-events-none touch-none w-6 h-6 lg:w-8 lg:h-8 text-[#FF3A3A] hover:scale-110 transform duration-200" />
            </button>
        </div>
        <div className="p-5 overflow-y-auto min-h-[450px]">
            <div className="flex flex-col justify-center items-center gap-3 pb-4">
            <img width={60} src={bookingConfirmation} alt="check"/>
            <p className="font-bold text-center text-xl">{t("BookingModal.paymentSuccessful")}</p>
            </div>
            <hr />
            <div className='flex flex-wrap gap-3 items-center py-4'>
                <img src={clubData?.photo_url} alt="Club Avatar" width={50} height={50} className='rounded-full object-cover' />
                <div className='capitalize'>
                    <p className='text-lg'>{clubData?.name}</p>
                    {membership?.start_date && <p className='text-sm'>{formatDate(moment(membership?.start_date).tz(fallbackTimeZone))}, {_formattedStartTime + ' - ' + _formattedEndTime}</p>}
                </div>
            </div>
            <hr />
            <div className="flex justify-between gap-5 items-center flex-wrap py-4">
            <p className="font-bold capitalize">{t("totalPayment")}</p>
            <p className="font-bold capitalize">
                {totalPayment} {clubData?.currency}
            </p>
            </div>
            {receiptUrl ? <hr /> : null}
            {receiptUrl ? (
                <div className="flex justify-between items-center gap-5 flex-wrap py-4">
                    <div className="text-xl font-medium">{t("receipt")}</div>
                    <div className="text-xl font-medium">
                        <a
                            href={receiptUrl}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <p className="text-black hover:scale-105 transform duration-200">
                                <FiDownload className="inline" size={25} />
                            </p>
                        </a>
                    </div>
                </div>
            ) : null}
            <div className='flex justify-center items-center mt-10'>
                <button onClick={() => {
                    setOpenPrivateMembershipModal(false);
                    setOpenOneTimeSuccessModal(false);
                }} className='bg-secondary min-w-[250px] text-white px-4 py-2 hover:bg-primary hover:text-secondary rounded-full text-base'>{t("close")}</button>
            </div>
        </div>
    </div>
  )
}

export default OneTimeSuccessModal